<script setup lang="ts">
// hooks
import { useStrapiSiteFooter } from '@api/strapi/site-footer/strapi-site-footer.hook'
// components
import SiteFooter from '@Widgets/Footers/SiteFooter.vue'

defineOptions({
  name: 'SiteFooterContainer',
})

const { refSiteFooter } = await useStrapiSiteFooter()
</script>

<template>
  <SiteFooter
    v-if="refSiteFooter"
    :data="refSiteFooter"
  />
</template>
